'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

// Same HubSpot portal used by the site's forms (NewsletterForm / Form).
const HUBSPOT_PORTAL_ID = '44722511';

/**
 * Loads the HubSpot tracking code and registers a page view for the current
 * route. Rendered only on the resource data-sheet pages, so HubSpot logs who
 * views them (identity resolves for contacts HubSpot already knows).
 */
export default function HubspotTracker() {
  const pathname = usePathname();

  useEffect(() => {
    const _hsq = (window._hsq = window._hsq || []);
    _hsq.push(['setPath', pathname]);
    _hsq.push(['trackPageView']);
  }, [pathname]);

  return (
    <Script
      id="hs-script-loader"
      strategy="afterInteractive"
      src={`https://js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`}
    />
  );
}
